import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MappingComponent} from '../../mapping/mapping.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-save-changes',
    templateUrl: './save-changes.component.html',
    styleUrls: ['./save-changes.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SaveChangesComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<MappingComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  saveChanges() {
    this.dialogRef.close({"option": "save"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"});
  }

}
